module.exports = __webpack_public_path__ + "img/ryzs10.5ea8689e.jpg";